module.exports = __webpack_public_path__ + "img/IMG_9543_FoamcoreMatted.85d94e69.jpg";